import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import LegalShieldPage from "@/pages/LegalShieldPage";
import KonnectMDPage from "@/pages/KonnectMDPage";
import LifeInsurancePage from "@/pages/LifeInsurancePage";
import TaxesPage from "@/pages/TaxesPage";
import AboutPage from "@/pages/AboutPage";
import MeetOwnerPage from "@/pages/MeetOwnerPage";
import MeetTeamPage from "@/pages/MeetTeamPage";
import PartnersPage from "@/pages/PartnersPage";
import CareersPage from "@/pages/CareersPage";
import CareersApplyPage from "@/pages/CareersApplyPage";
import ATTPage from "@/pages/ATTPage";
import ATTLayout from "@/pages/ATTLayout";
import ATTDevicesPage from "@/pages/ATTDevicesPage";
import ATTDeviceDetailPage from "@/pages/ATTDeviceDetailPage";
import VivintPage from "@/pages/VivintPage";
import WillTrustPage from "@/pages/WillTrustPage";
import CommunityPage from "@/pages/CommunityPage";
import TaxProPage from "@/pages/TaxProPage";
import ATTPlansPage from "@/pages/ATTPlansPage";
import ATTInternetPage from "@/pages/ATTInternetPage";
import ATTPreorderPage from "@/pages/ATTPreorderPage";
import ATTRepApplyPage from "@/pages/ATTRepApplyPage";
import ContactPage from "@/pages/ContactPage";
import BookCallPage from "@/pages/BookCallPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminQuotesPage from "@/pages/AdminQuotesPage";
import AdminATTPage from "@/pages/AdminATTPage";
import AdminApplicantsPage from "@/pages/AdminApplicantsPage";
import LinksPage from "@/pages/LinksPage";

const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/konnectmd/mgrainger" element={<ExternalRedirect to="https://www.konnectmdnow.com/index.aspx?ReferringDealerID=819349" />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/legalshield" element={<LegalShieldPage />} />
          <Route path="/konnectmd" element={<KonnectMDPage />} />
          <Route path="/healthcare" element={<KonnectMDPage />} />
          <Route path="/life-insurance" element={<LifeInsurancePage />} />
          <Route path="/taxes" element={<TaxesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/meet-the-owner" element={<MeetOwnerPage />} />
          <Route path="/meet-the-team" element={<MeetTeamPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/apply" element={<CareersApplyPage />} />
          <Route path="/att" element={<ATTLayout />}>
            <Route index element={<ATTPage />} />
            <Route path="devices" element={<ATTDevicesPage />} />
            <Route path="devices/:deviceId" element={<ATTDeviceDetailPage />} />
            <Route path="plans" element={<ATTPlansPage />} />
            <Route path="internet" element={<ATTInternetPage />} />
            <Route path="preorder" element={<ATTPreorderPage />} />
            <Route path="residential" element={<Navigate to="/att/preorder?aud=residential" replace />} />
            <Route path="business" element={<Navigate to="/att/preorder?aud=business" replace />} />
          </Route>
          <Route path="/careers/att-apply" element={<ATTRepApplyPage />} />
          <Route path="/careers/tax-pro" element={<TaxProPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/will-and-trust" element={<WillTrustPage />} />
          <Route path="/vivint" element={<VivintPage />} />
          <Route path="/security" element={<Navigate to="/vivint" replace />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book-a-call" element={<BookCallPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/admin/quotes" element={<AdminQuotesPage />} />
          <Route path="/admin/att" element={<AdminATTPage />} />
          <Route path="/admin/applicants" element={<AdminApplicantsPage />} />
          <Route path="/links" element={<LinksPage />} />
          {/* Short shareable shortcuts */}
          <Route path="/wireless" element={<Navigate to="/att" replace />} />
          <Route path="/internet" element={<Navigate to="/att" replace />} />
          <Route path="/legal" element={<Navigate to="/legalshield" replace />} />
          <Route path="/health" element={<Navigate to="/konnectmd" replace />} />
          <Route path="/life" element={<Navigate to="/life-insurance" replace />} />
          <Route path="/tax" element={<Navigate to="/taxes" replace />} />
          <Route path="/jobs" element={<Navigate to="/careers" replace />} />
          <Route path="/apply" element={<Navigate to="/careers/apply" replace />} />
          <Route path="/reps" element={<Navigate to="/careers/att-apply" replace />} />
          <Route path="/owner" element={<Navigate to="/meet-the-owner" replace />} />
          <Route path="/team" element={<Navigate to="/meet-the-team" replace />} />
          <Route path="/book" element={<Navigate to="/book-a-call" replace />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
